module.exports = __webpack_public_path__ + "static/media/looza-grapefruit.ae2a1b6b.jpg";